<template>
  <div>
    <div
      :class="['stake-row py-4', { 'has-divider': index > 0 }]"
      v-for="(dataItem, index) in stakeItems"
      :key="dataItem.type + dataItem.token"
    >
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6"
      >
        <span class="gray--text">Network</span>
        <div class="d-flex align-center">
          <span>{{ dataItem.name }}</span>
          <v-tooltip bottom :color="statusMap[dataItem.status.status].color">
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                :src="statusMap[dataItem.status.status].symbol"
                height="10"
                width="10"
                alt=""
                class="ml-2"
              />
            </template>
            <div class="text-6">
              {{ dataItem.status.displayStatus }}
            </div>
          </v-tooltip>
        </div>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Uptime</span>
        <span> {{ dataItem.uptime | numberFormat("0,0.00") }}%</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Voting Power</span>
        <span v-if="dataItem.votingPower.percentage"
          >{{
            dataItem.votingPower.percentage | numberFormat("0,0.00", false)
          }}%</span
        >
        <span v-else>-</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Total Staked AUMd</span>
        <span> ${{ dataItem.totalStakedAUM | numberFormat("0,0") }}</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">3-Days Avg Yield</span>
        <span>
          <v-tooltip bottom color="dark" min-width="170" disabled>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on"
                >{{ dataItem.yield3Days.apy | numberFormat("0,0.00", false) }}%
                APY</span
              >
            </template>
            <div class="text-6">
              APY Tooltips (disbaled)
            </div>
          </v-tooltip>
        </span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Ecosystem</span>
        <div class="d-flex align-center">
          <span>{{ dataItem.market.name }}</span>
          <img
            class="ml-2"
            :src="dataItem.market.logo"
            height="16"
            width="16"
            :alt="dataItem.market.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stakeItems: Array,
  },
  data: () => ({
    statusMap: {
      live: {
        symbol: require("@/assets/icons/status-live.svg"),
        color: "#00A253",
      },
      maintenance: {
        symbol: require("@/assets/icons/status-maintenance.svg"),
        color: "#FFA600",
      },
      offline: {
        symbol: require("@/assets/icons/status-offline.svg"),
        color: "#EB5757",
      },
    },
  }),
};
</script>

<style lang="scss" scoped>
.stake-row {
  &.has-divider {
    border-top: 1px solid #e9ebff;
  }
}
</style>
